<!-- Create Candidate modal start-->
<div class="modal-header b pb-0 px-3 pt-3 mb-3" *ngIf="calledFrom == ''">
  <h5 class="modal-title f-14 font-weight-600 text-defualt" id="createTalentTitle">Add Candidate to Talentpool</h5>
  <button data-testid="auto-app-add-to-talentpool-button-1" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
    (click)="closeAddToTPModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="px-3" *ngIf="!addCandidateCompleted" [ngClass]="{'mb-3' : !uiChange }">
  <div class="row">
    <div class="col-md-12 px-4">
      <div class="position-relative" [ngClass]="{'mb-1' : !uiChange }">

          <input data-testid="auto-app-add-to-talentpool-input-1" (input)="searchtalentpool($event)" type="text" placeholder="Select or create new Talentpool" #trigger="matAutocompleteTrigger"
          (keyup.enter)="trigger.closePanel()" class="wc-form-control nobg" #talentpool  [(ngModel)]="talentpoolname" [matAutocomplete]="talentpool_name">

          <mat-autocomplete #talentpool_name="matAutocomplete"  >
            <mat-option *ngFor="let talentpool of talentpools" [value]="talentpool.name" (onSelectionChange)="selecttalentpool(talentpool)">
              <div (click)="(talentpool.userAdded == true && hideCreateTalentpool == false) && openCreateTalentpool($event, talentpool)" class="d-flex justify-content-between align-items-center">
               <div>{{talentpool.name}}</div>
                <div [ngClass]="talentpool.userAdded == true && hideCreateTalentpool == false ? 'create-talentpool' : '' ">
                  <span *ngIf="talentpool.userAdded == true && hideCreateTalentpool == false"  style="color: #2e93a1;"> + Create & add new</span>
                </div>
              </div>
            </mat-option>
          </mat-autocomplete>

          <p *ngIf="noTalentpoolError" [ngClass]="['text-left','my-1','f-12','text-danger']">No Such Talentpool</p>

      </div>
    </div>

  </div>
  <div>
    <span class="f-12 text-danger">{{talentpoolerrormsg}}</span>
    <div class="col text-right pr-0" *ngIf="type == 'candidate'">
      <button data-testid="auto-app-add-to-talentpool-button-2" class="btn-trms-small" [disabled]="addToTalentpoolSpinner" (click)="openConfirmationModal()">
        <span [ngClass]="{ 'spinner-border text-light spinner-size': addToTalentpoolSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addToTalentpoolSpinner }">
          {{addToTalentpoolSpinner ? '' : 'Add'}}
        </span>
      </button>
    </div>
  </div>
</div>
<ng-container *ngIf="addCandidateCompleted">
  <div class="px-3">
    <p>{{postTPAddMssg}}</p>
    <div class="float-right d-flex flex-row justify-content-end mb-2">
      <button data-testid="auto-app-add-to-talentpool-button-3" class="outlined-button" *ngIf="addCandidateSuccess" style="width: fit-content; padding: 1rem; border-radius: .3125rem;" (click)="redirectToTalentPool()">
        View Talentpool
      </button>
      <button data-testid="auto-app-add-to-talentpool-button-4"  (click)="closeAddToTPModal()" class="ml-2 enabled-button" style="width: fit-content; padding: 1rem; border-radius: .3125rem;">
        <span *ngIf="addCandidateSuccess" (click)="ngOnInit()">Continue Search</span>
        <span *ngIf="!addCandidateSuccess">Close</span>
      </button>
    </div>
</div>
</ng-container>


<ng-template #confirmationModal>
  <!-- Create Candidate modal start-->
  <div class="modal-header b pb-0">
    <h5 class="modal-title" id="createTalentTitle"></h5>
    <button data-testid="auto-app-add-to-talentpool-button-5" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
      (click)="closeConfirmationDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <!-- <div class="row mb-4">
    <div class="col text-center">
      <img src="./../../../assets/images/applicationlane-confirmation.png" alt="img-fluid">
    </div>
  </div> -->
  <div class="modal-body pb-4 pt-0">
    <div class="row mb-3">
      <div class="col">
        <p>{{confirmation_message}}
        <p>
      </div>
    </div>
    <div class="row">
      <div class="col d-flex justify-content-end">
        <button data-testid="auto-app-add-to-talentpool-button-6" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
        <button data-testid="auto-app-add-to-talentpool-button-7"  class="btn-trms-small" [disabled]="addToTalentpoolSpinner" (click)="addCandidateToTalentpool()">
          <span [ngClass]="{ 'spinner-border text-light spinner-size': addToTalentpoolSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addToTalentpoolSpinner }">
            {{addToTalentpoolSpinner ? '' : 'YES'}}
          </span>
        </button>
      </div>
    </div>
  </div>

</ng-template>
<ng-template #successModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-add-to-talentpool-button-8" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/success-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">CONGRATULATIONS !!!</p>
          <p class="text-center">{{success_message}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-add-to-talentpool-button-9" class="btn-trms-white mx-auto" (click)="modalService.dismissAll()">CANCEL</button>
          <button data-testid="auto-app-add-to-talentpool-button-10" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">DONE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #errorModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-add-to-talentpool-button-11" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">ERROR</p>
          <p class="text-center">{{error_message}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-add-to-talentpool-button-12" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noCreditTalentpool class="modal">
  <div class="modal-content">
      <div class="modal-body px-6 pb-6 pt-3">
          <div class="row mb-3">
              <div class="col pb-5">
                  <button data-testid="auto-app-add-to-talentpool-button-13" type="button" class="close position-absolute tr0" data-dismiss="modal"
                      aria-label="Close" (click)="modalService.dismissAll()">
                      <span aria-hidden="true">×</span>
                  </button>
              </div>
          </div>
          <div class="row mb-6">
              <div class="col text-center mb-4">
                  <img src="../../assets/images/wallet.png" alt="img-fluid">
              </div>
          </div>
          <div class="row mb-3">
              <div class="col text-center" *ngIf="!uiChange">
                  <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
                  <p class=""  *ngIf="!isteamMember">You have exhausted your limit for creating talent pieplines</p>
                  <p class="" *ngIf="isteamMember">You have exhausted your limit creating talent pieplines, Request more credits from your team admin to keep
                    going</p>
              </div>
              <div class="col text-center" *ngIf="uiChange">
                <p class="font-weight-500 f-16 mb-2">Apologies, but you have utilized all your credits</p>
                <p class="">To add more credits and upgrade your account.</p>
            </div>
          </div>
          <div class="row"  *ngIf="!isteamMember">
              <div class="col-md-10 mx-auto d-flex">
                  <!-- <button data-testid="auto-app-add-to-talentpool-button-14" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modaldismiss()">CANCEL</button> -->
                  <button data-testid="auto-app-add-to-talentpool-button-15" class="btn-trms-medium m-auto" (click)="route2pricing()">Upgrade plan</button>
              </div>
          </div>
      </div>
  </div>
</ng-template>


<ngb-alert class="ngb-alert" *ngIf="success_message" type="success"  (close)="success_message = ''" >
  <span class="successCheck"><i class="fal fa-check"></i> </span>
 <span class="successmsg">{{ success_message }}</span>
</ngb-alert>
